import AuthSocial from "./AuthSocial";

export default AuthSocial;
